var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"href":item.href}},[_c('a',{staticClass:"breadcrumb-link"},[_vm._v(_vm._s(item.text.toUpperCase()))])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }